import Log from '@lib/Log'

export class Eloqua {
  public static readonly SiteID = 4150963
  public static readonly CookieWrite = 0

  public static getCustomerGUID(): string | null {
    try {
      const elqCustomerGuid = this.getCookieSubValue('ELOQUA', 'GUID')

      if (elqCustomerGuid != null && elqCustomerGuid != '') {
        return elqCustomerGuid
      }

      return null
    } catch (e) {
      Log.error(null, 'Failed to get eloqua customer GUID.')
      return null
    }
  }

  public static getFormName(
    productType: ProductType | undefined,
    industryType: IndustryType | undefined
  ): string | null {
    switch (productType) {
      case 'Auto':
        return 'LeadgenAuto'
      case 'Medsup':
        return 'LeadgenMedicareSupplement'
      case 'Medicare Advantage':
        return 'LeadgenMedicareAdvantage'
      case 'Guaranteed Issue':
        return 'LeadgenLifeGI'
      default: {
        switch (industryType) {
          case 'PNC':
            return 'LeadgenAuto'
          case 'Life':
            return 'LeadgenLife'
          case 'Medsup':
            return 'LeadgenMedicareSupplement'
          default: // "Disability"
            return 'LeadgenDisability'
        }
      }
    }
  }

  private static getCookieSubValue(name: string, subKey: string): string {
    const cookieValue = this.getCookie(name)

    if (cookieValue == null || cookieValue == '') {
      return ''
    }

    const cookieSubValue = cookieValue.split('&')

    for (let i in cookieSubValue) {
      const pair = cookieSubValue[i].split('=')

      if (pair.length > 1) {
        if (pair[0] == subKey) {
          return pair[1]
        }
      }
    }

    return ''
  }

  private static getCookie(name: string): string {
    const cookies = document.cookie.split(';')

    for (let i in cookies) {
      const cookie = cookies[i]
      const position = cookie.indexOf('=')

      if (position > 0 && position < cookie.length - 1) {
        let x = cookie.substr(0, position)
        const y = cookie.substr(position + 1)
        x = x.replace(/^\s+|\s+$/g, '')

        if (x == name) {
          return unescape(y)
        }
      }
    }

    return ''
  }
}
